import { fmtMoney, fmtMoneyShort, fmtNum, fmtNumShort, fmtPeriodo, CHART_COLORS } from '../components/kpiUtils';

const TIPO_COLORS = {
  'Usuario': '#6366f1', 'Cuenta': '#f43f5e', 'Limite alerta': '#f59e0b', 'Limite bloqueo retiro': '#0ea5e9',
};
const GEN_COLORS = { 'Masculino': '#3b82f6', 'Femenino': '#ec4899' };
const PREST_ESTADO_COLORS = {
  'Rechazado': '#f43f5e', 'Vigente': '#10b981', 'Mora': '#f59e0b',
  'Cancelado': '#94a3b8', 'Solicitado': '#0ea5e9', 'Aprobado': '#22c55e',
};
const fmtHoras = (h) => {
  if (h === null || h === undefined) return '—';
  const n = Number(h);
  if (n < 1) return `${Math.round(n * 60)} min`;
  if (n < 48) return `${n.toFixed(1)} h`;
  return `${(n / 24).toFixed(1)} d`;
};
const fmtFecha = (iso) => { if (!iso) return '—'; const [, m, d] = String(iso).slice(0, 10).split('-'); return `${d}/${m}`; };
const last = (arr) => (arr && arr.length ? arr[arr.length - 1] : null);

export const SECCIONES_LABEL = {
  'kpis-ingresos': 'Ingresos', 'kpis-adquisicion': 'Descargas', 'kpis-adopcion': 'Bonda',
  'kpis-clientes-activos': 'Clientes activos', 'kpis-bloqueos': 'Bloqueos', 'kpis-afiliacion': 'Afiliación',
  'kpis-prestamos': 'Préstamos', 'kpis-cuenta-remunerada': 'Cuenta Remunerada', 'kpis-atencion': 'Atención al Cliente',
};

export const WIDGETS = [
  // Ingresos
  { wid: 'ing_total_hist', seccion: 'kpis-ingresos', titulo: 'Ingresos — total histórico', tipo: 'kpi', accent: '#4f46e5' },
  { wid: 'ing_mes_total', seccion: 'kpis-ingresos', titulo: 'Ingresos del mes', tipo: 'kpi', periodica: true, accent: '#4f46e5' },
  { wid: 'ing_evolucion', seccion: 'kpis-ingresos', titulo: 'Ingresos — evolución mensual', tipo: 'chart', accent: '#4f46e5' },
  { wid: 'ing_fuentes_mes', seccion: 'kpis-ingresos', titulo: 'Ingresos por fuente (mes)', tipo: 'chart', periodica: true, accent: '#4f46e5' },
  // Descargas
  { wid: 'desc_total', seccion: 'kpis-adquisicion', titulo: 'Descargas totales', tipo: 'kpi', accent: '#0ea5e9' },
  { wid: 'desc_mes', seccion: 'kpis-adquisicion', titulo: 'Descargas del mes', tipo: 'kpi', periodica: true, accent: '#0ea5e9' },
  { wid: 'desc_evolucion', seccion: 'kpis-adquisicion', titulo: 'Descargas — evolución (iOS/Android)', tipo: 'chart', accent: '#0ea5e9' },
  // Bonda
  { wid: 'bonda_canjes', seccion: 'kpis-adopcion', titulo: 'Canjes Bonda (total)', tipo: 'kpi', accent: '#10b981' },
  { wid: 'bonda_usuarios', seccion: 'kpis-adopcion', titulo: 'Usuarios que canjean', tipo: 'kpi', accent: '#10b981' },
  { wid: 'bonda_evolucion', seccion: 'kpis-adopcion', titulo: 'Bonda — evolución', tipo: 'chart', accent: '#10b981' },
  { wid: 'bonda_top_partners', seccion: 'kpis-adopcion', titulo: 'Bonda — top partners', tipo: 'chart', accent: '#10b981' },
  // Clientes activos
  { wid: 'ca_activos', seccion: 'kpis-clientes-activos', titulo: 'Clientes activos', tipo: 'kpi', accent: '#6366f1' },
  { wid: 'ca_bloqueados', seccion: 'kpis-clientes-activos', titulo: 'Clientes bloqueados', tipo: 'kpi', accent: '#f43f5e' },
  { wid: 'ca_saldo', seccion: 'kpis-clientes-activos', titulo: 'Con saldo ≥ $8.000', tipo: 'kpi', accent: '#10b981' },
  { wid: 'ca_mau_evo', seccion: 'kpis-clientes-activos', titulo: 'MAU — evolución', tipo: 'chart', accent: '#6366f1' },
  // Bloqueos
  { wid: 'blq_total', seccion: 'kpis-bloqueos', titulo: 'Bloqueos totales', tipo: 'kpi', accent: '#f43f5e' },
  { wid: 'blq_escalado', seccion: 'kpis-bloqueos', titulo: 'Escalado usuario → CVU', tipo: 'kpi', accent: '#f59e0b' },
  { wid: 'blq_por_tipo', seccion: 'kpis-bloqueos', titulo: 'Bloqueos por tipo', tipo: 'chart', accent: '#f43f5e' },
  { wid: 'blq_por_mes', seccion: 'kpis-bloqueos', titulo: 'Bloqueos por mes', tipo: 'chart', accent: '#f43f5e' },
  { wid: 'ros_total', seccion: 'kpis-bloqueos', titulo: 'ROS generados', tipo: 'kpi', accent: '#4f46e5' },
  { wid: 'ros_por_mes', seccion: 'kpis-bloqueos', titulo: 'ROS por mes', tipo: 'chart', accent: '#4f46e5' },
  // Afiliación
  { wid: 'afi_total', seccion: 'kpis-afiliacion', titulo: 'Afiliados totales', tipo: 'kpi', accent: '#7c3aed' },
  { wid: 'afi_mes', seccion: 'kpis-afiliacion', titulo: 'Altas del mes', tipo: 'kpi', periodica: true, accent: '#7c3aed' },
  { wid: 'afi_altas_evo', seccion: 'kpis-afiliacion', titulo: 'Afiliación — altas por mes', tipo: 'chart', accent: '#7c3aed' },
  { wid: 'afi_provincia', seccion: 'kpis-afiliacion', titulo: 'Afiliados por provincia', tipo: 'chart', accent: '#7c3aed' },
  { wid: 'afi_genero', seccion: 'kpis-afiliacion', titulo: 'Afiliados por género', tipo: 'chart', accent: '#7c3aed' },
  // Préstamos
  { wid: 'pre_total', seccion: 'kpis-prestamos', titulo: 'Préstamos — solicitudes', tipo: 'kpi', accent: '#059669' },
  { wid: 'pre_tasa_aprob', seccion: 'kpis-prestamos', titulo: 'Tasa de aprobación', tipo: 'kpi', accent: '#10b981' },
  { wid: 'pre_mora', seccion: 'kpis-prestamos', titulo: 'Préstamos en mora', tipo: 'kpi', accent: '#f59e0b' },
  { wid: 'pre_monto', seccion: 'kpis-prestamos', titulo: 'Monto otorgado', tipo: 'kpi', accent: '#7c3aed' },
  { wid: 'pre_estado', seccion: 'kpis-prestamos', titulo: 'Préstamos por estado', tipo: 'chart', accent: '#059669' },
  { wid: 'pre_mes', seccion: 'kpis-prestamos', titulo: 'Solicitudes por mes', tipo: 'chart', accent: '#059669' },
  { wid: 'pre_monto_mes', seccion: 'kpis-prestamos', titulo: 'Monto otorgado por mes', tipo: 'chart', accent: '#7c3aed' },
  { wid: 'pre_promedio', seccion: 'kpis-prestamos', titulo: 'Préstamo promedio (más frecuente)', tipo: 'kpi', accent: '#0ea5e9' },
  { wid: 'pre_rango', seccion: 'kpis-prestamos', titulo: 'Distribución por rango de monto', tipo: 'chart', accent: '#059669' },
  // Cuenta Remunerada
  { wid: 'crem_cuentas', seccion: 'kpis-cuenta-remunerada', titulo: 'Cuentas remuneradas', tipo: 'kpi', accent: '#0d9488' },
  { wid: 'crem_saldo', seccion: 'kpis-cuenta-remunerada', titulo: 'Saldo remunerado', tipo: 'kpi', accent: '#4f46e5' },
  { wid: 'crem_remun_acum', seccion: 'kpis-cuenta-remunerada', titulo: 'Remuneración acumulada', tipo: 'kpi', accent: '#7c3aed' },
  { wid: 'crem_saldo_serie', seccion: 'kpis-cuenta-remunerada', titulo: 'Saldo remunerado (diario)', tipo: 'chart', accent: '#0d9488' },
  { wid: 'crem_remun_mes', seccion: 'kpis-cuenta-remunerada', titulo: 'Costo de remuneración por mes', tipo: 'chart', accent: '#f59e0b' },
  // Atención al Cliente
  { wid: 'att_total', seccion: 'kpis-atencion', titulo: 'Tickets', tipo: 'kpi', accent: '#0284c7' },
  { wid: 'att_abiertos', seccion: 'kpis-atencion', titulo: 'Tickets abiertos', tipo: 'kpi', accent: '#f59e0b' },
  { wid: 'att_cerrados', seccion: 'kpis-atencion', titulo: 'Tickets cerrados', tipo: 'kpi', accent: '#10b981' },
  { wid: 'att_mes', seccion: 'kpis-atencion', titulo: 'Tickets por mes', tipo: 'chart', accent: '#0284c7' },
  { wid: 'att_estado', seccion: 'kpis-atencion', titulo: 'Tickets por estado', tipo: 'chart', accent: '#0284c7' },
  { wid: 'att_grupo_abiertos', seccion: 'kpis-atencion', titulo: 'Abiertos por grupo', tipo: 'chart', accent: '#f59e0b' },
  { wid: 'att_motivo', seccion: 'kpis-atencion', titulo: 'Top motivos de consulta', tipo: 'chart', accent: '#6366f1' },
];

export const WIDGETS_BY_ID = Object.fromEntries(WIDGETS.map((w) => [w.wid, w]));

export function widgetPeriodos(wid, blob) {
  const w = WIDGETS_BY_ID[wid];
  if (!w || !blob) return [];
  switch (w.seccion) {
    case 'kpis-ingresos': return blob.ingresos?.periodos || [];
    case 'kpis-adquisicion': return (blob.descargas?.por_mes || []).map((m) => m.periodo);
    case 'kpis-adopcion': return (blob.bonda?.por_mes || []).map((m) => m.periodo);
    case 'kpis-clientes-activos': return (blob.clientes?.mau || []).map((m) => m.mes);
    case 'kpis-bloqueos': return (blob.bloqueos?.limites?.por_mes || []).map((m) => m.periodo);
    case 'kpis-afiliacion': return (blob.afiliacion?.por_mes || []).map((m) => m.periodo);
    default: return [];
  }
}

// Devuelve { kind:'kpi', label, value, accent, deltaLabel } | { kind:'chart', title, accent, chartProps }
export function computeWidget(wid, blob, config = {}) {
  const w = WIDGETS_BY_ID[wid];
  if (!w || !blob) return null;
  const per = config.periodo || null;
  const kpi = (label, value, deltaLabel) => ({ kind: 'kpi', label, value, accent: w.accent, deltaLabel });
  const chart = (title, chartProps) => ({ kind: 'chart', title, accent: w.accent, chartProps });

  switch (wid) {
    // ---- Ingresos ----
    case 'ing_total_hist':
      return kpi(w.titulo, fmtMoney(blob.ingresos?.total_historico), 'histórico');
    case 'ing_mes_total': {
      const pm = blob.ingresos?.por_mes || [];
      const row = per ? pm.find((x) => x.periodo === per) : last(pm);
      return kpi(`Ingresos · ${row ? fmtPeriodo(row.periodo) : '—'}`, fmtMoney(row?.total), 'total del mes');
    }
    case 'ing_evolucion': {
      const data = (blob.ingresos?.por_mes || []).map((m) => ({ label: fmtPeriodo(m.periodo, true), total: m.total }));
      return chart(w.titulo, { data, series: [{ key: 'total', name: 'Ingresos', color: w.accent }], type: 'area', valueFormatter: fmtMoney, axisFormatter: fmtMoneyShort, height: 260, showLegend: false });
    }
    case 'ing_fuentes_mes': {
      const negs = blob.ingresos?.negocios || [];
      const p = per || last(blob.ingresos?.periodos || []);
      const rows = negs.map((n, i) => ({ label: n.nombre, total: Number((n.montos || {})[p] || 0), _c: n.color || CHART_COLORS[i % CHART_COLORS.length] }))
        .filter((r) => r.total > 0).sort((a, b) => b.total - a.total);
      return chart(`${w.titulo}${p ? ` · ${fmtPeriodo(p)}` : ''}`, { data: rows, xKey: 'label', series: [{ key: 'total', name: 'Ingreso', color: w.accent }], type: 'barras', barLayout: 'vertical', cellColors: rows.map((r) => r._c), height: Math.max(160, rows.length * 40), valueFormatter: fmtMoney, axisFormatter: fmtMoneyShort, showLegend: false });
    }
    // ---- Descargas ----
    case 'desc_total': {
      const t = blob.descargas?.totales || {};
      return kpi(w.titulo, fmtNum(t.total), `iOS ${fmtNum(t.ios)} · Android ${fmtNum(t.android)}`);
    }
    case 'desc_mes': {
      const pm = blob.descargas?.por_mes || [];
      const row = per ? pm.find((x) => x.periodo === per) : last(pm);
      return kpi(`Descargas · ${row ? fmtPeriodo(row.periodo) : '—'}`, fmtNum(row?.total), `iOS ${fmtNum(row?.ios)} · And ${fmtNum(row?.android)}`);
    }
    case 'desc_evolucion': {
      const data = (blob.descargas?.por_mes || []).map((m) => ({ label: fmtPeriodo(m.periodo, true), ios: m.ios, android: m.android }));
      return chart(w.titulo, { data, series: [{ key: 'ios', name: 'iOS', color: '#6366f1' }, { key: 'android', name: 'Android', color: '#10b981' }], type: 'barras', stacked: true, valueFormatter: fmtNum, axisFormatter: fmtNumShort, height: 260 });
    }
    // ---- Bonda ----
    case 'bonda_canjes':
      return kpi(w.titulo, fmtNum(blob.bonda?.totales?.canjes), 'canjes de cupones');
    case 'bonda_usuarios':
      return kpi(w.titulo, fmtNum(blob.bonda?.totales?.usuarios_unicos), 'usuarios únicos');
    case 'bonda_evolucion': {
      const data = (blob.bonda?.por_mes || []).map((m) => ({ label: fmtPeriodo(m.periodo, true), canjes: m.canjes }));
      return chart(w.titulo, { data, series: [{ key: 'canjes', name: 'Canjes', color: w.accent }], type: 'area', valueFormatter: fmtNum, axisFormatter: fmtNumShort, height: 260, showLegend: false });
    }
    case 'bonda_top_partners': {
      const rows = (blob.bonda?.por_partner || []).map((p) => ({ label: p.partner, total: p.canjes }));
      return chart(w.titulo, { data: rows, xKey: 'label', series: [{ key: 'total', name: 'Canjes', color: w.accent }], type: 'barras', barLayout: 'vertical', cellColors: CHART_COLORS, height: Math.max(160, rows.length * 34), valueFormatter: fmtNum, axisFormatter: fmtNumShort, showLegend: false });
    }
    // ---- Clientes activos ----
    case 'ca_activos':
      return kpi(w.titulo, fmtNum(blob.clientes?.totals?.activos), 'con CVU + Habilitado');
    case 'ca_bloqueados':
      return kpi(w.titulo, fmtNum(blob.clientes?.totals?.bloqueados), 'con CVU + Deshabilitado');
    case 'ca_saldo':
      return kpi(w.titulo, fmtNum(blob.clientes?.totals?.con_saldo_8000), 'de los activos');
    case 'ca_mau_evo': {
      const data = (blob.clientes?.mau || []).map((m) => ({ label: fmtPeriodo(m.mes, true), mau: m.mau }));
      return chart(w.titulo, { data, series: [{ key: 'mau', name: 'MAU', color: w.accent }], type: 'area', valueFormatter: fmtNum, axisFormatter: fmtNumShort, height: 260, showLegend: false });
    }
    // ---- Bloqueos ----
    case 'blq_total':
      return kpi(w.titulo, fmtNum(blob.bloqueos?.limites?.total), `${fmtNum(blob.bloqueos?.limites?.personas)} personas`);
    case 'blq_escalado': {
      const e = blob.bloqueos?.limites?.escalado_usuario_cvu || {};
      return kpi(w.titulo, `${e.pct ?? 0}%`, `${fmtNum(e.escalaron_a_cvu)} de ${fmtNum(e.con_bloqueo_usuario)}`);
    }
    case 'blq_por_tipo': {
      const rows = (blob.bloqueos?.limites?.por_tipo || []).map((t) => ({ label: t.tipo, total: t.total }));
      return chart(w.titulo, { data: rows, xKey: 'label', series: [{ key: 'total', name: 'Bloqueos', color: w.accent }], type: 'barras', barLayout: 'vertical', cellColors: rows.map((r) => TIPO_COLORS[r.label] || '#94a3b8'), height: Math.max(160, rows.length * 42), valueFormatter: fmtNum, axisFormatter: fmtNumShort, showLegend: false });
    }
    case 'blq_por_mes': {
      const tipos = blob.bloqueos?.limites?.tipos || [];
      const data = (blob.bloqueos?.limites?.por_mes || []).map((m) => {
        const row = { label: fmtPeriodo(m.periodo, true) };
        tipos.forEach((t) => { row[t] = m[t] || 0; });
        return row;
      });
      const series = tipos.map((t, i) => ({ key: t, name: t, color: TIPO_COLORS[t] || CHART_COLORS[i % CHART_COLORS.length] }));
      return chart(w.titulo, { data, series, type: 'barras', stacked: true, valueFormatter: fmtNum, axisFormatter: fmtNumShort, height: 260 });
    }
    case 'ros_total':
      return kpi(w.titulo, fmtNum(blob.bloqueos?.ros?.total), 'reportes de op. sospechosa');
    case 'ros_por_mes': {
      const data = (blob.bloqueos?.ros?.por_mes || []).map((m) => ({ label: fmtPeriodo(m.periodo, true), total: m.total }));
      return chart(w.titulo, { data, series: [{ key: 'total', name: 'ROS', color: w.accent }], type: 'area', valueFormatter: fmtNum, axisFormatter: fmtNumShort, height: 260, showLegend: false });
    }
    // ---- Afiliación ----
    case 'afi_total':
      return kpi(w.titulo, fmtNum(blob.afiliacion?.total), 'padrón de afiliados');
    case 'afi_mes': {
      const pm = blob.afiliacion?.por_mes || [];
      const row = per ? pm.find((x) => x.periodo === per) : last(pm);
      return kpi(`Altas · ${row ? fmtPeriodo(row.periodo) : '—'}`, fmtNum(row?.altas), 'altas del mes');
    }
    case 'afi_altas_evo': {
      const data = (blob.afiliacion?.por_mes || []).map((m) => ({ label: fmtPeriodo(m.periodo, true), altas: m.altas }));
      return chart(w.titulo, { data, series: [{ key: 'altas', name: 'Altas', color: w.accent }], type: 'area', valueFormatter: fmtNum, axisFormatter: fmtNumShort, height: 260, showLegend: false });
    }
    case 'afi_provincia': {
      const rows = (blob.afiliacion?.por_provincia || []).map((p) => ({ label: p.provincia, total: p.total }));
      return chart(w.titulo, { data: rows, xKey: 'label', series: [{ key: 'total', name: 'Afiliados', color: w.accent }], type: 'barras', barLayout: 'vertical', cellColors: CHART_COLORS, height: Math.max(160, rows.length * 30), valueFormatter: fmtNum, axisFormatter: fmtNumShort, showLegend: false });
    }
    case 'afi_genero': {
      const rows = (blob.afiliacion?.por_genero || []).map((g) => ({ label: g.label, total: g.total }));
      return chart(w.titulo, { data: rows, xKey: 'label', series: [{ key: 'total', name: 'Afiliados', color: w.accent }], type: 'barras', barLayout: 'vertical', cellColors: rows.map((r) => GEN_COLORS[r.label] || '#a78bfa'), height: Math.max(140, rows.length * 44), valueFormatter: fmtNum, axisFormatter: fmtNumShort, showLegend: false });
    }
    // ---- Préstamos ----
    case 'pre_total':
      return kpi(w.titulo, fmtNum(blob.prestamos?.kpis?.total), `${fmtNum(blob.prestamos?.kpis?.aprobados)} aprobados`);
    case 'pre_tasa_aprob':
      return kpi(w.titulo, `${blob.prestamos?.kpis?.tasa_aprobacion ?? 0}%`, 'de los decididos');
    case 'pre_mora':
      return kpi(w.titulo, fmtNum(blob.prestamos?.kpis?.en_mora), `${blob.prestamos?.kpis?.tasa_mora ?? 0}% de otorgados`);
    case 'pre_monto':
      return kpi(w.titulo, fmtMoney(blob.prestamos?.kpis?.monto_otorgado), 'monto otorgado');
    case 'pre_estado': {
      const rows = (blob.prestamos?.por_estado || []).map((e) => ({ label: e.estado, total: e.total }));
      return chart(w.titulo, { data: rows, xKey: 'label', series: [{ key: 'total', name: 'Préstamos', color: w.accent }], type: 'barras', barLayout: 'vertical', cellColors: rows.map((r) => PREST_ESTADO_COLORS[r.label] || '#94a3b8'), height: Math.max(160, rows.length * 42), valueFormatter: fmtNum, axisFormatter: fmtNumShort, showLegend: false });
    }
    case 'pre_mes': {
      const estados = blob.prestamos?.estados || [];
      const data = (blob.prestamos?.por_mes || []).map((m) => {
        const row = { label: fmtPeriodo(m.periodo, true) };
        estados.forEach((e) => { row[e] = m[e] || 0; });
        return row;
      });
      const series = estados.map((e, i) => ({ key: e, name: e, color: PREST_ESTADO_COLORS[e] || CHART_COLORS[i % CHART_COLORS.length] }));
      return chart(w.titulo, { data, series, type: 'barras', stacked: true, valueFormatter: fmtNum, axisFormatter: fmtNumShort, height: 260 });
    }
    case 'pre_monto_mes': {
      const data = (blob.prestamos?.monto_por_mes || []).map((m) => ({ label: fmtPeriodo(m.periodo, true), monto: m.monto }));
      return chart(w.titulo, { data, series: [{ key: 'monto', name: 'Otorgado', color: '#7c3aed' }], type: 'area', valueFormatter: fmtMoney, axisFormatter: fmtMoneyShort, height: 260, showLegend: false });
    }
    case 'pre_promedio':
      return kpi(w.titulo, fmtMoney(blob.prestamos?.kpis?.prestamo_promedio), 'monto más frecuente');
    case 'pre_rango': {
      const rows = (blob.prestamos?.por_rango || []).map((r) => ({ label: r.rango, total: r.total }));
      return chart(w.titulo, { data: rows, xKey: 'label', series: [{ key: 'total', name: 'Préstamos', color: w.accent }], type: 'barras', barLayout: 'vertical', cellColors: CHART_COLORS, height: Math.max(180, rows.length * 38), valueFormatter: fmtNum, axisFormatter: fmtNumShort, showLegend: false });
    }
    // ---- Cuenta Remunerada ----
    case 'crem_cuentas':
      return kpi(w.titulo, fmtNum(blob.cuenta_remunerada?.kpis?.cuentas), 'cuentas remuneradas');
    case 'crem_saldo':
      return kpi(w.titulo, fmtMoney(blob.cuenta_remunerada?.kpis?.saldo_total), 'saldo remunerado');
    case 'crem_remun_acum':
      return kpi(w.titulo, fmtMoney(blob.cuenta_remunerada?.kpis?.remuneracion_acumulada), 'período cargado');
    case 'crem_saldo_serie': {
      const data = (blob.cuenta_remunerada?.serie || []).map((s) => ({ label: fmtFecha(s.fecha), saldo: s.saldo }));
      return chart(w.titulo, { data, series: [{ key: 'saldo', name: 'Saldo', color: w.accent }], type: 'area', valueFormatter: fmtMoney, axisFormatter: fmtMoneyShort, height: 260, showLegend: false });
    }
    case 'crem_remun_mes': {
      const data = (blob.cuenta_remunerada?.por_mes || []).map((m) => ({ label: fmtPeriodo(m.periodo, true), remuneracion: m.remuneracion }));
      return chart(w.titulo, { data, series: [{ key: 'remuneracion', name: 'Remuneración', color: '#f59e0b' }], type: 'barras', valueFormatter: fmtMoney, axisFormatter: fmtMoneyShort, height: 260, showLegend: false });
    }
    // ---- Atención al Cliente ----
    case 'att_total':
      return kpi(w.titulo, fmtNum(blob.atencion?.kpis?.total), `${fmtNum(blob.atencion?.kpis?.cerrados)} cerrados`);
    case 'att_abiertos':
      return kpi(w.titulo, fmtNum(blob.atencion?.kpis?.abiertos), 'sin cerrar');
    case 'att_cerrados':
      return kpi(w.titulo, fmtNum(blob.atencion?.kpis?.cerrados), 'resueltos / cerrados');
    case 'att_mes': {
      const data = (blob.atencion?.por_mes || []).map((m) => ({ label: fmtPeriodo(m.periodo, true), total: m.total }));
      return chart(w.titulo, { data, series: [{ key: 'total', name: 'Tickets', color: w.accent }], type: 'area', valueFormatter: fmtNum, axisFormatter: fmtNumShort, height: 260, showLegend: false });
    }
    case 'att_estado': {
      const rows = (blob.atencion?.por_estado || []).map((e) => ({ label: e.estado, total: e.total }));
      return chart(w.titulo, { data: rows, xKey: 'label', series: [{ key: 'total', name: 'Tickets', color: w.accent }], type: 'barras', barLayout: 'vertical', cellColors: CHART_COLORS, height: Math.max(160, rows.length * 40), valueFormatter: fmtNum, axisFormatter: fmtNumShort, showLegend: false });
    }
    case 'att_grupo_abiertos': {
      const rows = (blob.atencion?.por_grupo_abiertos || []).map((g) => ({ label: g.grupo, total: g.total }));
      return chart(w.titulo, { data: rows, xKey: 'label', series: [{ key: 'total', name: 'Abiertos', color: w.accent }], type: 'barras', barLayout: 'vertical', cellColors: CHART_COLORS, height: Math.max(160, rows.length * 40), valueFormatter: fmtNum, axisFormatter: fmtNumShort, showLegend: false });
    }
    case 'att_motivo': {
      const rows = (blob.atencion?.por_motivo || []).map((m) => ({ label: m.motivo, total: m.total }));
      return chart(w.titulo, { data: rows, xKey: 'label', series: [{ key: 'total', name: 'Tickets', color: '#6366f1' }], type: 'barras', barLayout: 'vertical', cellColors: CHART_COLORS, height: Math.max(180, rows.length * 34), valueFormatter: fmtNum, axisFormatter: fmtNumShort, showLegend: false });
    }
    default:
      return null;
  }
}
